"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _styles = require("@material-ui/core/styles");

var _Autocomplete = _interopRequireDefault(require("@material-ui/lab/Autocomplete"));

var _TextField = _interopRequireDefault(require("@material-ui/core/TextField"));

var _excluded = ["label"];

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

var useAutocompleteCustomStyles = (0, _styles.makeStyles)(function () {
  return {
    root: {
      "&&": {
        border: "1px solid #979797",
        overflow: "hidden",
        borderRadius: 0,
        backgroundColor: "white",
        height: "50px",
        "&:hover": {
          backgroundColor: "white"
        }
      },
      "& .MuiAutocomplete-inputRoot": {
        padding: "5px"
      },
      "& .MuiInputLabel-shrink": {
        fontSize: "14px",
        top: 0
      },
      "& .MuiInput-underline::before": {
        content: "normal",
        borderBottom: 0,
        transition: "none"
      },
      "& .MuiInput-underline::after": {
        content: "normal",
        border: "1px solid #979797"
      },
      "& .MuiAutocomplete-endAdornment": {
        top: "calc(50% - 24px)"
      },
      error: {
        "&&": {
          border: "1px solid red",
          "&$focused": {
            border: "1px solid red"
          }
        }
      }
    }
  };
});
var useLabelStylesCustom = (0, _styles.makeStyles)(function () {
  return {
    root: {
      color: "#979797",
      padding: "5px",
      top: "-8px",
      "&$focused": {
        color: "#979797",
        fontSize: "14px",
        top: 0
      }
    },
    focused: {},
    error: {
      "&$focused": {
        color: "red"
      }
    }
  };
});

var Autocomplete = function Autocomplete(_ref) {
  var label = _ref.label,
      rest = _objectWithoutProperties(_ref, _excluded);

  var autocompleteClasses = useAutocompleteCustomStyles();
  var labelClasses = useLabelStylesCustom();
  return /*#__PURE__*/_react.default.createElement(_Autocomplete.default, _extends({}, rest, {
    options: rest.options,
    groupBy: rest.groupBy,
    getOptionLabel: rest.getOptionLabel,
    classes: autocompleteClasses,
    renderInput: function renderInput(params) {
      return /*#__PURE__*/_react.default.createElement(_TextField.default, _extends({}, params, {
        label: label,
        size: "small",
        InputLabelProps: {
          classes: labelClasses
        }
      }));
    }
  }));
};

var _default = Autocomplete;
exports.default = _default;